export default __webpack_public_path__ + "static/media/miguel-lopes-8.d8dffc77.jpg";